import * as React from 'react';

import {Modal} from './modal';

import styles from './image-modal.module.css';

type Props = {
    sidebar: {
        image: React.ReactElement<any>;
        backgroundColor: string;
    };
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
};

export class ImageModal extends React.PureComponent<Props> {
    render() {
        const {children, sidebar, ...otherProps} = this.props;

        return (
            <Modal {...otherProps} noPadding={true}>
                <div className={styles.container}>
                    <div style={{backgroundColor: sidebar.backgroundColor}} className={styles.left}>
                        {sidebar.image}
                    </div>
                    <div className={styles.right}>{children}</div>
                </div>
            </Modal>
        );
    }
}
